// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionAuditResponse
 */
export interface IContributionAuditResponse {
    /**
     * 
     * @type {number}
     * @memberof IContributionAuditResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionAuditResponse
     */
    changed_by_name: string;
    /**
     * 
     * @type {Date}
     * @memberof IContributionAuditResponse
     */
    changed_at: Date;
    /**
     * 
     * @type {string}
     * @memberof IContributionAuditResponse
     */
    action_type: string;
    /**
     * 
     * @type {number}
     * @memberof IContributionAuditResponse
     */
    changes_count: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionAuditResponse
     */
    updated_employees_number?: number;
}

/**
 * Check if a given object implements the IContributionAuditResponse interface.
 */
export function instanceOfIContributionAuditResponse(value: object): value is IContributionAuditResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('changed_by_name' in value) || value['changed_by_name'] === undefined) return false;
    if (!('changed_at' in value) || value['changed_at'] === undefined) return false;
    if (!('action_type' in value) || value['action_type'] === undefined) return false;
    if (!('changes_count' in value) || value['changes_count'] === undefined) return false;
    return true;
}

export function IContributionAuditResponseFromJSON(json: any): IContributionAuditResponse {
    return IContributionAuditResponseFromJSONTyped(json, false);
}

export function IContributionAuditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionAuditResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'changed_by_name': json['changed_by_name'],
        'changed_at': (new Date(json['changed_at'])),
        'action_type': json['action_type'],
        'changes_count': json['changes_count'],
        'updated_employees_number': json['updated_employees_number'] == null ? undefined : json['updated_employees_number'],
    };
}

export function IContributionAuditResponseToJSON(json: any): IContributionAuditResponse {
    return IContributionAuditResponseToJSONTyped(json, false);
}

export function IContributionAuditResponseToJSONTyped(value?: IContributionAuditResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'changed_by_name': value['changed_by_name'],
        'changed_at': ((value['changed_at']).toISOString()),
        'action_type': value['action_type'],
        'changes_count': value['changes_count'],
        'updated_employees_number': value['updated_employees_number'],
    };
}

